import {memo, useEffect, useState} from "react";
import {Link} from "react-router-dom";
import {handleRequest, apiError, numberFormat} from "~/utils";
import {dashboardApi} from "~/api";
import FontAwesomeIcon from "~/components/FontAwesome";
import {Image} from "~/components";
import DashboardWidgetHeader from "./DashboardWidgetHeader";

/**
 * Widget dashboard đào tạo: 10 NV kinh doanh có doanh thu thấp nhất trong tháng.
 * Nguồn: dashboardApi.saleLowestPerformers() (cùng logic Báo cáo tổng hợp đánh giá NVKD).
 */
function LowestPerformersWidget({
	title = '10 NV kết quả thấp nhất',
	icon = 'fa-light fa-arrow-trend-down',
	gradient = 'linear-gradient(135deg, #b91c1c 0%, #dc2626 60%, #ef4444 100%)',
}) {

	const [items, setItems]     = useState([]);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		let mounted = true;
		setLoading(true);
		handleRequest(dashboardApi.saleLowestPerformers()).then(([err, res]) => {
			if (!mounted) return;
			if (!apiError('', err, res) && res?.data) {
				setItems(res.data);
			}
			setLoading(false);
		});
		return () => { mounted = false; };
	}, []);

	const viewAllLink = (
		<Link to="/report/sales/staff-summary" style={{
			color: '#fff', fontSize: 11, opacity: 0.85,
			display: 'flex', alignItems: 'center', gap: 3, textDecoration: 'none',
		}}>
			Xem báo cáo <FontAwesomeIcon icon="fa-light fa-arrow-right" />
		</Link>
	);

	return (
		<div style={{borderRadius: 16, overflow: 'hidden', boxShadow: '0 2px 12px rgba(239,68,68,0.12)', background: '#fff'}}>
			<DashboardWidgetHeader
				icon={icon}
				title={title}
				gradient={gradient}
				extra={viewAllLink}
			/>

			<div style={{padding: '12px 18px'}}>
				{loading && (
					<div style={{textAlign: 'center', padding: '16px 0', color: '#94a3b8', fontSize: 13}}>
						<FontAwesomeIcon icon="fa-light fa-loader" spin style={{marginRight: 6}} />
						Đang tải...
					</div>
				)}

				{!loading && items.length === 0 && (
					<div style={{textAlign: 'center', padding: '20px 0', color: '#94a3b8'}}>
						<FontAwesomeIcon icon="fa-light fa-users" style={{fontSize: 26, display: 'block', marginBottom: 6}} />
						<span style={{fontSize: 12}}>Chưa có dữ liệu nhân viên kinh doanh</span>
					</div>
				)}

				{!loading && items.map((item, index) => {
					const name   = item.firstname ? `${item.firstname} ${item.lastname}` : `#${item.id}`;
					const isLast = index === items.length - 1;

					return (
						<div key={`lowest-${item.id}`} style={{
							display: 'flex', gap: 10, alignItems: 'center',
							paddingBottom: isLast ? 4 : 12, marginBottom: isLast ? 0 : 12,
							borderBottom: isLast ? 'none' : '1px dashed #e2e8f0',
						}}>
							<div style={{
								width: 22, height: 22, flexShrink: 0, borderRadius: '50%',
								background: '#f1f5f9', color: '#64748b', fontSize: 11, fontWeight: 700,
								display: 'flex', alignItems: 'center', justifyContent: 'center',
							}}>{index + 1}</div>

							<div className="avatar" style={{width: 40, height: 40, flexShrink: 0}}><Image src={item.avatar} /></div>

							<div style={{flex: 1, minWidth: 0}}>
								<b style={{fontSize: 13, color: '#1e293b', display: 'block', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}>{name}</b>
								<p style={{fontSize: 11, color: '#64748b', margin: 0}}>{item.username}</p>
							</div>

							<div style={{textAlign: 'right', flexShrink: 0}}>
								<b style={{fontSize: 13, color: '#ef4444'}}>{numberFormat(item.revenue)}</b>
								<p style={{fontSize: 11, color: '#94a3b8', margin: 0}}>Doanh thu</p>
							</div>
						</div>
					);
				})}
			</div>
		</div>
	);
}

export default memo(LowestPerformersWidget);
